<template>
  <a :class="buttonClass" @click.prevent="$emit('click')">
    <div class="d-flex align-center justify-center">
      <slot />
      <i v-if="loading" class="fa fa-spinner fa-spin ml-1" />
    </div>
  </a>
</template>

<script>
export default {
  name: 'vkb-btn',

  props: {
    isCta: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    buttonClass() {
      const classes = ['button'];

      if (this.loading || this.disabled) {
        classes.push('disabled');
      }

      if (this.isCta) {
        classes.push('call-to-action');
      }

      return classes;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/vkb-btn.vue